class FeedCalculator extends HTMLElement {
  currentStepNumber = 0
  currentStep = null
  product = []
  _settings = {}

  constructor() {
    super();
  }
  connectedCallback() {
    this.steps = [...this.querySelectorAll('[data-step]')]
    this.startButton = this.querySelector('[data-calculator-trigger]')
    this.startScreen = this.querySelector('[data-start-screen]')

    this.addEventListener('step:next', this.next)
    this.addEventListener('step:prev', this.prev)
    this.addEventListener('step:select', event => {
      this.select(event.detail.index)
    })

    this.startButton.addEventListener('click', this.next.bind(this))
  }

  get settings (){
    return this._settings;
  }

  scrollToTop(){
    this.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  updatedVisibility(){
    this.scrollToTop()
    this.currentStep.dispatchEvent(new CustomEvent('step:init'))
  }

  select(index){
    this.currentStepNumber = index
    this._hideSteps()

    this.steps[index].classList?.remove('hidden')

    this.currentStep = this.steps[index]
    this.startScreen.classList.add('hidden')

    this.updatedVisibility()
  }

  next(){
    this.currentStepNumber = Math.min(this.currentStepNumber + 1, this.steps.length)
    const currentStepIndex = this.currentStepNumber - 1

    this._hideSteps()

    this.steps[currentStepIndex].classList?.remove('hidden')

    this.currentStep = this.steps[currentStepIndex]
    this.startScreen.classList.add('hidden')

    this.updatedVisibility()
  }

  prev(){
    this.currentStepNumber = Math.max(this.currentStepNumber - 1 , 0)
    const currentStepIndex = this.currentStepNumber - 1

    this._hideSteps()

    this.steps[currentStepIndex]?.classList.remove('hidden')
    this.currentStep = this.steps[currentStepIndex]

    this.startScreen.classList.toggle('hidden', this.currentStepNumber !== 0)

    this.updatedVisibility()
  }

  _hideSteps(){
    this.steps.forEach(step => step.classList.add('hidden'))
  }

  pushState(key, value){
    if(!key || !value) return;

    this._settings[key] = value;
  }
}
if (!window.customElements.get("feed-calculator")) {
  window.customElements.define("feed-calculator", FeedCalculator);
}

class FeedCalculatorStep extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.controller = this.closest('feed-calculator')
    this.nextButtons = this.querySelectorAll('[data-button-next]')
    this.backButtons = this.querySelectorAll('[data-button-back]')
    this.selectStepButton = this.querySelectorAll('[data-button-step]')

    this.nextButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.controller.dispatchEvent(new CustomEvent('step:next'))
      })
    })

    this.backButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.controller.dispatchEvent(new CustomEvent('step:prev'))
      })
    })

    this.selectStepButton.forEach(button => {
      const {buttonStep: stepIndex} = button.dataset

      button.addEventListener('click', () => {
        this.controller.dispatchEvent(new CustomEvent('step:select', {
          detail: {
            index: stepIndex
          }
        }))
      })
    })

    this.addEventListener('change', this.changeHandler)
  }
}

class FeedCalculatorStepInput extends FeedCalculatorStep {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();

    this.inputType = this.dataset.inputType;
    this.key = this.dataset.key;
    this.value = this.querySelector('[type="number"], [type="text"], [type="radio"]:checked')?.value
    this.input = this.querySelector('input')

    this.controller.pushState(this.key, this.value);
    this.addEventListener('change', this.changeHandler)
    this.addEventListener('keyup', this.changeHandler)

    this.changeHandler()
  }

  changeHandler({target}){
    this.value = target.value;

    if (target.type == 'number') {
      const wrapper = target.closest('.feed-calculator-step__content-wrapper');
      const placeholder = wrapper.querySelector('.feed-calculator-step__input-placeholder');

      if (target.value === '') {
        placeholder.textContent = '1';
        
      } else {
        placeholder.textContent = target.value;
      }

      wrapper.style.setProperty('--text-width', `${placeholder.offsetWidth}px`);
    }

    this.controller.pushState(this.key, this.value);
    this.nextButtons.forEach(button => button.toggleAttribute('disabled', !this.value))
  }
}
if (!window.customElements.get("feed-calculator-step-input")) {
  window.customElements.define("feed-calculator-step-input", FeedCalculatorStepInput);
}

class FeedCalculatorStepProducts extends FeedCalculatorStep {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();

    this.products = [...this.querySelectorAll('[data-product]')]?.map(productElement => {
      return {
        data: JSON.parse(productElement.querySelector('[type="application/json"]').innerHTML || '{}'),
        input: productElement.querySelector('input'),
        productFormElement: productElement.querySelector('template')?.content.querySelector('[data-product-from]'),
        productTableElement: productElement.querySelector('template')?.content.querySelector('[data-table-content]')
      }
    })

    this.addEventListener('step:init', this.init)
    this.addEventListener('change', this.changeHandler)
  }

  init(){
    this.nextButtons.forEach(button => button.setAttribute('disabled', ''))

    this.products.forEach(({input}) => input.checked = false)
    const weight = this.controller.settings.weight || 1


    this.validProducts = this.products.filter(productData => {
      return +productData.input.dataset.minWeight <= +weight
    })

    this.products.forEach(({input}) => input.setAttribute('disabled', ''))
    this.validProducts.forEach(({input}) => input.removeAttribute('disabled'))
  }

  changeHandler({target}){
    if(target.name !== 'feed-calculator-product') return;

    this.controller.product = this.products.find(productData => productData.input === target)

    this.nextButtons.forEach(button => button.removeAttribute('disabled'))
  }
}
if (!window.customElements.get("feed-calculator-step-products")) {
  window.customElements.define("feed-calculator-step-products", FeedCalculatorStepProducts);
}

class FeedCalculatorStepResults extends FeedCalculatorStep {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();

    this.dailyServingPattern = this.querySelector('template')?.content.querySelector('[data-daily-serving]')?.innerHTML
    this.contentElement = this.querySelector('[data-result-text]')
    this.tableElement = this.querySelector('[data-table-content]')
    this.tableWrapperElement = this.querySelector('.feed-calculator__table')
    this.formContainers = this.querySelectorAll('[data-products-container]');
    this.elementsReplacements = [...this.querySelectorAll('[data-text-replacement]')];
    this.elementsReplacementsContents = this.elementsReplacements.map(element => element.innerHTML)

    this.addEventListener('step:init', this.init)
  }

  init(){
    this.updateContent()
    this.updateTable()
    this.updateLink()

    this.formContainers.forEach(formContainer => {
      formContainer.innerHTML = this.controller.product.productFormElement.outerHTML
    })

    this.dailyServingElements = this.querySelectorAll('[data-daily-serving]');

    this.dailyServingElements.forEach(dailyServingElement => dailyServingElement.innerHTML = this.calcDailyServing())
  }

  updateLink(){
    this.linkElement = this.linkElement || this.querySelector('[data-product-href]')
    if(!this.linkElement) return

    this.linkElement.href = this.controller.product.data.url;
  }

  updateTable(){
    this.tableWrapperElement?.classList.toggle('hidden', this.controller.product.data.type !== "Futtertopping");

    if(!this.controller.product.productTableElement || !this.tableElement) return

    this.tableElement.innerHTML = this.controller.product.productTableElement.innerHTML
  }

  updateContent(){
    if(!this.elementsReplacements.length) return;
    this.elementsReplacements.forEach((element, index) => {
      let updatedText = this.elementsReplacementsContents[index];

      Object.keys(this.controller.settings).forEach(key => {
        let value = this.controller.settings[key].toLowerCase()

        if (key === 'name') value = this.capitalizeFirstLetter(value)

        updatedText = updatedText.replace(`[${key}]`, value)
      });

      updatedText = updatedText.replace('[product_title]', this.controller.product.data.title);

      element.textContent = updatedText;
    })
  }

  renderDaily() {
    const staticRows = this.querySelectorAll('.feed-calculator__wrapper--result [data-daily-static]');
    const dynamicRows = this.querySelectorAll('.feed-calculator__wrapper--result [data-daily-dynamic]');

    if (!dynamicRows.length || !staticRows.length) return;

    const dogWeight = Number(this.controller.settings.weight || 1);
    const productData = this.controller.product.data;

    let result = '';

    // Futtertopping → conservative calculation
    if (productData.type === 'Futtertopping') {
      const productWeight = 250;
      if (!productWeight) return;

      // 1. daily portion (always round UP)
      const dailyPortion = Math.ceil(dogWeight * 0.3);

      // 2. days (keep decimal)
      const days = productWeight / dailyPortion;

      // 3. weeks (always round DOWN)
      const weeks = Math.floor(days / 7);

      result = `${weeks} Wochen`;
    }
    // Other products → existing JSON logic
    else {
      const table = productData.table;
      if (!table || !table.columns || !table.rows) return;

      const gewichtIndex = table.columns.indexOf('Gewicht');
      const reichweiteIndex = table.columns.indexOf('Reichweite');
      if (gewichtIndex === -1 || reichweiteIndex === -1) return;

      const row = table.rows.find(row => {
        const range = row[gewichtIndex];
        if (!range) return false;

        const [min, max] = range
          .replace('kg', '')
          .split('-')
          .map(Number);

        return dogWeight >= min && dogWeight <= max;
      });

      result = row ? row[reichweiteIndex] : '';
    }

    if (!result) return;

    staticRows.forEach(row => row.classList.add('hidden'));

    dynamicRows.forEach(row => {
      row.classList.remove('hidden');
      const rich = row.querySelector('[data-daily-dynamic-rich]');
      if (rich) rich.innerHTML = result;
    });
  }

  calcDailyServing(){
    const weight = this.controller.settings.weight || 1

    const {table: servingPerKilogramTable, type: productType} = this.controller.product.data

    this.renderDaily();

    if(productType === "Futtertopping"){
      const value = (servingPerKilogramTable.rows.at(-1)[1].split(' ')[0].replace(',', '.') * weight).toFixed(1).replace('.', ',');
      return this.dailyServingPattern.replace('[value]', value).replace('[spoons]', value)
    }else {
      const currentRow = servingPerKilogramTable.rows.find(([weightRange]) =>{
        let min = weightRange.split(' ')[0].split('-')[0];
        let max = weightRange.split(' ')[0].split('-')[1].replace('kg', '');

        return +weight >= +min && +max > +weight
      })

      if (!currentRow) {
        return ''
      }

      return currentRow[1]
    }
  }

  capitalizeFirstLetter(word) {
    if (word.length === 0) {
      return "";
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
}
if (!window.customElements.get("feed-calculator-step-result")) {
  window.customElements.define("feed-calculator-step-result", FeedCalculatorStepResults);
}